import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
    palette: {
        primary: {
            main: "#2AB1BF", // Adjust color to match your design
        },
        secondary: {
            main: "#1C236D", // Adjust secondary color if needed
        },
        search: {
            main: '#F1F1F1',
        },
        background: {
            default: "##F1F1F1", // Light background similar to the image
            paper: "#FFFFFF",
        },
        button: {
            main: "#2AB1BF",
            clear: "#CB444A",
            filter: "#1C236D",
            save: "#1C236D",
            cancel: "#F1F1F1",
        },
        action: {
            hover: "#2AB1BF"
        },
        text: {
            main: "#000000",
            cancel: "#1C236D",
            gray: "#6C6C6C"
        },
        status: {
            active: "#E6F1E6",
            inactive: "#E6EDF1",
        }
    },
    typography: {
        fontFamily: "'Poppins', sans-serif", // Use Google Font similar to the image
        h1: {
            fontSize: '3.5rem',
        },
        h2: {
            fontSize: '2.5rem',
        },
        h3: {
            fontSize: '2rem',
        },
        h4: {
            fontSize: '1.75rem',
        },
        h5: {
            fontSize: '1.5rem',
        },
        h6: {
            fontSize: '1.25rem',
        },
        body1: {
            fontSize: '1rem',
        },
        body2: {
            fontSize: '0.875rem',
        },
        button: {
            fontSize: '1rem',
        },
        caption: {
            fontSize: '0.75rem',
        },
    },
    components: {
        MuiTab: {
            styleOverrides: {
                root: {
                    fontSize: "13px",
                    color: "#6C6C6C",
                    fontWeight: "500",
                    backgroundColor: "#FFFFFF",
                    "&:hover": {
                        color: "white",
                        fontWeight: "600",
                        backgroundColor: "#1C236D",
                        borderTopLeftRadius: "10px",
                        borderTopRightRadius: "10px",
                    },
                    "&.Mui-selected": {
                        color: "white",
                        fontWeight: "600",
                        backgroundColor: "#1C236D",
                        borderTopLeftRadius: "10px",
                        borderTopRightRadius: "10px",
                    }
                }
            }
        },
        MuiTable: {
            styleOverrides: {
                root: {
                    borderRadius: "8px",
                    fontSize: "14px",
                },
            },
        },
        MuiTableRow: {
            styleOverrides: {
                root: {
                    '& .MuiTableCell-root': {
                        fontWeight: "500",
                        fontSize: "14px",
                        color: "#1A1A1A",
                    },
                    '&:nth-of-type(even)': {
                        backgroundColor: '#EDF7F8',
                        '&:hover': {
                            backgroundColor: '#F5F5F5',
                        },
                    },
                    '&:hover': {
                        cursor: 'pointer',
                        '& .MuiTableCell-root': {
                            backgroundColor: '#F5F5F5',
                        },
                    },
                    '& .MuiTableCell-root .MuiTypography-root': {
                        fontWeight: "500",
                        fontSize: "14px",
                        color: "#1A1A1A",
                    }
                }
            }
        },
        MuiTableHead: {
            styleOverrides: {
                root: {
                    "& .MuiTableRow-root": {
                        fontSize: "14px",
                        color: "#90909A",
                        '& .MuiTableCell-root': {
                            fontWeight: "500",
                            color: "#90909A",
                            fontSize: "14px",
                        },
                        '&:hover': {
                            '& .MuiTableCell-root': {
                                color: "#90909A",
                            },
                        }
                    },
                    '& .MuiTableRow-root .MuiTypography-root': {
                        fontWeight: "500",
                        fontSize: "14px",
                        color: "#90909A",
                    }
                },

            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: "8px", // Rounded corners
                    textTransform: "none", // Avoid uppercase text
                    fontWeight: "bold",
                },
            },
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    "& .MuiOutlinedInput-root": {
                        borderRadius: "8px",
                        "&.Mui-focused fieldset": {
                            borderColor: "#2196F3", // Highlight focus color
                        },
                    },
                },
            },
        },
    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 900,
            lg: 1200,
            xl: 1536,
            xll: 1920,
        },
    },
});